module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About The Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("By the same author:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("The Liberals in Hampshire - a part(l)y history.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Part 1: Southampton 1958-65: object lessons")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Part 2: Eastleigh 1965-72: out in the suburbs, something stirred!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Part 3: Eastleigh 1972-81: the thorn in the flesh bursts into flower")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Part 4: Eastleigh 1978-85: a campaign in pictures - politics can be fun!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Part 5: Eastleigh 1981-90: control!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Martin Kyrle’s "), _c('em', [_vm._v("Little Green Nightbook")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Martin Kyrle’s "), _c('em', [_vm._v("Little Blue Nightbook")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Jottings from the Trans-Siberian Railway")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Jottings from Russia and the Baltic States. Part 1: Russia and Estonia")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("A 20-20 Vision. Turning Britain into a liberal democracy")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("In preparation:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Jottings from Russia and the Baltic States. Part 2: Latvia, Lithuania and Finland")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("A Victorian Childhood")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0